import {
  DEFAULT_ISLAND_KEY,
  buildIslandPlaybookPath,
  getIslandItineraryLabel,
  getIslandPlaybookBasePath,
  normalizePlaybookSlugPath,
} from 'alakai-aloha-shared';
import { getRuntimeSiteContext } from './siteContext';

export function getPlaybookBasePath(islandKey = DEFAULT_ISLAND_KEY) {
  return getIslandPlaybookBasePath(islandKey);
}

export function buildPlaybookPath(slugPath = '', islandKey = DEFAULT_ISLAND_KEY) {
  return buildIslandPlaybookPath(islandKey, slugPath);
}

export function getItineraryLabel(islandKey = DEFAULT_ISLAND_KEY) {
  return getIslandItineraryLabel(islandKey);
}

export { normalizePlaybookSlugPath };

export function getRuntimePlaybookBasePath() {
  return getPlaybookBasePath(getRuntimeSiteContext().island);
}

export function buildRuntimePlaybookPath(slugPath = '') {
  return buildPlaybookPath(slugPath, getRuntimeSiteContext().island);
}

export function getRuntimeItineraryLabel() {
  return getItineraryLabel(getRuntimeSiteContext().island);
}
